import React,{useEffect,useRef,useState} from 'react';
import './Login.css';
import OkiruLogo from './OkiruLogo';
const SHARED='https://okiru.app/toolkit-auth?toolkit=learn';
export default function Login({notice=''}) {
 useEffect(()=>{if(!notice)window.location.replace(SHARED);},[notice]);
 return <main className="login-screen"><section className="login-card"><OkiruLogo/><h1>Okiru Learn</h1>{notice&&<p role="alert">{notice}</p>}<p>One account for the app and all your authorised toolkits.</p><a href={SHARED}>Continue to Okiru</a></section></main>;
}
export function SsoSessionExchange({token,onLogin}) {
 const [error,setError]=useState('');
 const exchange=useRef(null);
 useEffect(()=>{let current=true;
  window.history.replaceState({},'',window.location.pathname);
  if(!exchange.current)exchange.current=fetch('/api/auth/sso-session',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({token})})
   .then(async r=>{const data=await r.json();if(!r.ok||!data.success)throw Error('Your Learn session could not be opened. Continue through Okiru to try again.');return data;});
  exchange.current
   .then(data=>{if(current)onLogin(data.data);}).catch(()=>{if(current)setError('Your Learn session could not be opened. Continue through Okiru to try again.');});
  return ()=>{current=false;};
 },[token]);
 return error?<Login notice={error}/>:<p role="status">Opening your Okiru Learn account...</p>;
}
